// ----- DO NOT MODIFY THIS FILE DIRECTLY -----
// This file is auto-generated by stack9-cli based on Modules in packages/stack9-stack/stack9.config.json.
// Re-run `stack9 stack up` to regenerate it after changing your Modules.
// ----- DO NOT MODIFY THIS FILE DIRECTLY -----

export const stack9StandardModuleComponents = [];

export const stack9StandardModuleRoutes = [];
